import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const EditAssignmentUniversity = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState("");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/assignment/${id}`)
      .then((response) => {
        const assignmentData = response.data || {};
        setLanguage(assignmentData.language || "");
        setTitle(assignmentData.title || "");
        setFile(null);
      })
      .catch((error) => {
        console.error("Error fetching assignment:", error);
      });
  }, [API_BASE_URL, id]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create FormData to handle file uploads and other form data
    const formData = new FormData();
    formData.append("language", language);
    formData.append("title", title);

    if (file) {
      formData.append("univercityassignmentpdf", file); // Only append the file if it's changed
    }

    const role = localStorage.getItem("role");
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/assignment/${id}`
        : `${API_BASE_URL}/admin/assignment/${id}`;


    // Send PUT request to update the assignment
    axios
      .put(
        // `${API_BASE_URL}/admin/assignment/${id}`,
        endpoint,
        formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log("Assignment updated successfully:", response.data);
        alert("Assignment updated successfully");
        // Navigate or provide feedback after successful update
        navigate("/student-assignment/all-university");
      })
      .catch((error) => {
        console.error("Error updating assignment:", error);
        alert("Error updating assignment");
      });
  };

  return (
    <div>
      <div id="assignment-university-main-container">
        <div className="ass-university-heading-or-btns">
          <h4>Edit University Assignment</h4>
          <div className="ass-university-nav-btns">
            <button>University Assignment</button>
            <button
              onClick={() => navigate("/student-assignment/all-university")}
            >
              University All Assignments
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="note-detail-form">
          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Language</label>
            <select
              className="new-chapter-dropdown"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              required
            >
              <option value="">-Select Language-</option>
              <option value="english">English</option>
              <option value="hindi">Hindi</option>
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Title</label>
            <input
              type="text"
              placeholder="Enter Title"
              className="new-chapter-dropdown"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">File</label>
            <input
              type="file"
              className="new-chapter-dropdown"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </div>

          <div className="form1-btns">
            <button type="submit" className="btn-save">
              Update Assignment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAssignmentUniversity;
